import { DoneActorEvent } from 'xstate';
import {
  AuthenticateSuccessEvent,
  AuthMachineContext,
  AuthMachineEvents,
} from '../types';

export function setUserContext({
  context,
  event,
}: {
  context: AuthMachineContext;
  event: AuthMachineEvents;
}) {
  if (!event.type.includes('xstate.done.actor')) return context;

  const e = event as DoneActorEvent<AuthenticateSuccessEvent>;
  if (e.output.type !== 'AUTHENTICATE_SUCCESS') return context;

  return {
    accessToken: e.output.accessToken,
    ignoreRefreshToken: false,
    user: e.output.user ?? null,
  };
}

export default setUserContext;
